/**
 * RawJsonCard - Displays unknown JSON structures as formatted code
 */
import { cn } from '@/lib/utils'

export interface RawJsonCardProps {
  data: unknown
  className?: string
}

export function RawJsonCard({ data, className }: RawJsonCardProps) {
  return (
    <pre 
      data-testid="raw-json-content"
      className={cn(
        "font-mono text-xs bg-muted p-3 rounded-lg overflow-x-auto",
        className
      )}
    >
      {JSON.stringify(data, null, 2)}
    </pre>
  )
}
